<template>
    <Button label="Добавить" icon="pi pi-plus" class="text-sm border-round-lg" @click="showDialog" severity="success" size="small"/>

    <Dialog class="flex flex-column border-none" modal
        v-model:visible="dialog"
        :position="screenSize=='xs' ? 'bottom' : 'center'"
        :style="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? {width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important'} : { width: '900px' }"
        :contentStyle="(screenSize=='xs' || screenSize=='sm' || screenSize=='md') ? { height: '100%' } : { height: 'auto' }"
        :class="(screenSize=='xs') ? 'h-full border-noround-bottom' : ''">

        <template #header>
            <div class="flex flex-column w-full mb-3">
                <span class="flex text-lg font-medium">Добавить пользователя</span>
            </div>
        </template>

        <div class="flex flex-column w-full gap-3">
            <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row md:flex-row">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Email <span class="text-red-500">*</span>: </span>
                    <InputText v-model="userData.email" type="email" placeholder="user@example.com" class="w-full"/>
                </div>

                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Логин <span class="text-red-500">*</span>: </span>
                    <InputText v-model="userData.login" placeholder="username" class="w-full"/>
                </div>
            </div>

            <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row md:flex-row">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Пароль <span class="text-red-500">*</span>: </span>
                    <div class="flex gap-2 align-items-start">
                        <Password v-model="userData.password" :feedback="false" toggleMask placeholder="Не менее 8 символов" class="w-full" inputClass="w-full"/>
                        <Button icon="pi pi-refresh" severity="secondary" outlined @click="userData.password = generatePassword(16)" v-tooltip.top="'Сгенерировать пароль'"/>
                    </div>
                </div>

                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Имя: </span>
                    <InputText v-model="userData.name" placeholder="Имя пользователя" class="w-full"/>
                </div>
            </div>

            <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row md:flex-row">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Проект: </span>
                    <Select v-model="userData.project_id" :options="projectOptions" optionLabel="label" optionValue="id" placeholder="Выберите проект" class="w-full"/>
                </div>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Коды доступа (через запятую): </span>
                <InputText v-model="accessCodesText" placeholder="admin_users_edit, admin_wallets" class="w-full"/>
            </div>

            <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row md:flex-row">
                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Success URL: </span>
                    <InputText v-model="userData.success_url" placeholder="https://example.com/success" class="w-full"/>
                </div>

                <div class="flex flex-column w-full gap-2">
                    <span class="flex">Fail URL: </span>
                    <InputText v-model="userData.fail_url" placeholder="https://example.com/fail" class="w-full"/>
                </div>
            </div>

            <div class="flex flex-column w-full gap-2">
                <span class="flex">Webhook URL: </span>
                <InputText v-model="userData.webhook_url" placeholder="https://example.com/webhook" class="w-full"/>
            </div>

            <Divider />

            <div class="flex flex-column w-full gap-3">
                <div class="flex justify-content-between align-items-center">
                    <span class="text-lg font-medium">Платежные системы</span>
                    <Button label="Добавить" icon="pi pi-plus" @click="addPaymentSystem" size="small" severity="success"/>
                </div>

                <div v-for="(ps, index) in userData.payment_systems" :key="index" class="flex flex-column w-full gap-2 p-3 border-1 surface-border border-round">
                    <div class="flex justify-content-between align-items-center mb-2">
                        <span class="font-medium">Система #{{ index + 1 }}</span>
                        <Button icon="pi pi-trash" @click="removePaymentSystem(index)" size="small" severity="danger" text/>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Система <span class="text-red-500">*</span>: </span>
                        <Select v-model="ps.system" :options="systemOptions" placeholder="Выберите систему" class="w-full"/>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Merchant ID <span class="text-red-500">*</span>: </span>
                        <InputText v-model="ps.merchant_id" placeholder="merchant_id" class="w-full"/>
                    </div>

                    <div class="flex align-items-center gap-2">
                        <Checkbox v-model="ps.kyc_required" :binary="true" :inputId="'add_kyc_required_' + index"/>
                        <label :for="'add_kyc_required_' + index" class="text-sm">Требуется KYC</label>
                    </div>

                    <div class="flex w-full gap-2 flex-column xl:flex-row lg:flex-row">
                        <div class="flex flex-column flex-1 gap-2">
                            <span class="flex text-sm">Мин. лимит (₽): </span>
                            <InputNumber v-model="ps.min_limit" class="w-full" :min="0" placeholder="100"/>
                        </div>
                        <div class="flex flex-column flex-1 gap-2">
                            <span class="flex text-sm">Макс. лимит (₽): </span>
                            <InputNumber v-model="ps.max_limit" class="w-full" :min="0" placeholder="1000000"/>
                        </div>
                    </div>

                    <div class="flex flex-column w-full gap-2">
                        <span class="flex text-sm">Параметры (JSON): </span>
                        <Textarea v-model="ps.paramsJson" rows="3" placeholder='{"key": "value"}' class="w-full"/>
                        <small v-if="ps.paramsError" class="text-red-500">{{ ps.paramsError }}</small>
                    </div>
                </div>

                <div v-if="!userData.payment_systems || userData.payment_systems.length === 0" class="text-center text-500 p-3">
                    Нет добавленных платежных систем
                </div>
            </div>
        </div>

        <template #footer>
            <div class="w-full mb-3 flex justify-content-between flex-wrap">
                <Button label="Создать" @click="AddUser()" :loading="loading" class="flex" :disabled="loading || !isValid" severity="success"/>
                <Button label="Закрыть" icon="pi pi-times" @click="dialog = false" outlined class="flex" autofocus severity="secondary" :disabled="loading"/>
            </div>
        </template>

    </Dialog>
</template>

<script>
import Connect from '@/assets/js/connect.js'
import Helper from '@/assets/js/helper.js'

export default {
    data() {
        return {
            loading: false,
            dialog: false,
            userData: {
                project_id: '',
                email: '',
                login: '',
                name: '',
                password: '',
                access_codes: [],
                payment_systems: [],
                success_url: '',
                fail_url: '',
                webhook_url: '',
                
            },
            accessCodesText: '',
            // Заполните реальные project ids для отправки в API.
            projectOptions: [
                { label: 'PaySido', id: '699ead66c13e000266f72745' },
                { label: 'PaySame', id: '69ddfa476b47e9aea51ae0e2' },
            ],
            systemOptions: ['tbank', 'dolinsk_bank', 'kanyonpay', 'easy_pay', 'panacea_pay', 'loveandpay', 'netpay'],
        }
    },
    computed: {
        screenSize() { return this.$store.getters.StateScreenSize },
        isValid() {
            if(!this.userData.email || !this.validateEmail(this.userData.email)) return false
            if(!this.userData.login) return false
            if(!this.userData.password || this.userData.password.length < 8) return false
            if(this.userData.project_id && this.userData.project_id.length !== 24) return false

            if(this.userData.payment_systems && this.userData.payment_systems.length > 0) {
                for(const ps of this.userData.payment_systems) {
                    if(!ps.system || !ps.merchant_id) return false
                    if(ps.paramsError) return false
                }
            }

            return true
        }
    },
    methods: {
        showMess(severity, summary, detail) {
            this.$toast.add({severity: severity, summary: summary, detail: detail, life: 3000});
        },
        validateEmail(email) {
            const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            return re.test(email)
        },
        showDialog(){
            this.dialog = true
            this.resetForm()
        },
        resetForm() {
            this.userData = {
                project_id: '',
                email: '',
                login: '',
                name: '',
                password: this.generatePassword(16),
                access_codes: [],
                payment_systems: [],
                success_url: '',
                fail_url: '',
                webhook_url: '',
                
            }
            this.accessCodesText = ''
        },
        generatePassword(length = 16) {
            const letters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
            const digits = '0123456789'
            const symbols = '!@#$%^&*()-_=+[]{};:,.?'
            const allChars = letters + digits + symbols
            const result = []

            // Гарантируем хотя бы по одному символу каждого типа.
            result.push(letters[Math.floor(Math.random() * letters.length)])
            result.push(digits[Math.floor(Math.random() * digits.length)])
            result.push(symbols[Math.floor(Math.random() * symbols.length)])

            while(result.length < length) {
                result.push(allChars[Math.floor(Math.random() * allChars.length)])
            }

            // Перемешиваем символы, чтобы обязательные типы не были в фиксированных позициях.
            for(let i = result.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1))
                const tmp = result[i]
                result[i] = result[j]
                result[j] = tmp
            }

            return result.join('')
        },
        addPaymentSystem() {
            this.userData.payment_systems.push({
                system: '',
                kyc_required: true,
                merchant_id: '',
                min_limit: 100,
                max_limit: 1000000,
                paramsJson: '{}',
                paramsError: null
            })
        },
        removePaymentSystem(index) {
            this.userData.payment_systems.splice(index, 1)
        },
        validatePaymentSystems() {
            let valid = true
            for(const ps of this.userData.payment_systems) {
                try {
                    JSON.parse(ps.paramsJson || '{}')
                    ps.paramsError = null
                } catch(e) {
                    ps.paramsError = 'Неверный формат JSON'
                    valid = false
                }
            }
            return valid
        },
        parseCsvList(value) {
            if(!value) return []
            return value
                .split(',')
                .map(item => item.trim())
                .filter(item => item)
        },
        async AddUser(){
            this.loading = true

            if(!this.userData.email || !this.validateEmail(this.userData.email)){
                this.showMess('error', 'Ошибка', 'Неверный формат email')
                this.loading = false
                return
            }

            if(!this.userData.login){
                this.showMess('error', 'Ошибка', 'Логин обязателен')
                this.loading = false
                return
            }

            if(!this.userData.password || this.userData.password.length < 8){
                this.showMess('error', 'Ошибка', 'Пароль должен содержать минимум 8 символов')
                this.loading = false
                return
            }

            if(this.userData.project_id && this.userData.project_id.length !== 24){
                this.showMess('error', 'Ошибка', 'Project ID должен быть длиной 24 символа')
                this.loading = false
                return
            }

            if(!this.validatePaymentSystems()) {
                this.showMess('error', 'Ошибка', 'Проверьте параметры платежных систем')
                this.loading = false
                return
            }

            const access_codes = this.parseCsvList(this.accessCodesText)
            // Формируем payload только из заполненных необязательных полей под Joi-схему.
            const createData = {
                email: this.userData.email,
                login: this.userData.login,
                password: this.userData.password,
                name: this.userData.name || null,
                success_url: this.userData.success_url || null,
                fail_url: this.userData.fail_url || null,
                webhook_url: this.userData.webhook_url || null,
                payment_systems: this.userData.payment_systems.map(ps => ({
                    system: ps.system,
                    kyc_required: ps.kyc_required,
                    merchant_id: ps.merchant_id,
                    min_limit: ps.min_limit,
                    max_limit: ps.max_limit,
                    params: JSON.parse(ps.paramsJson || '{}')
                }))
            }

            if(this.userData.project_id) createData.project_id = this.userData.project_id
            if(access_codes.length > 0) createData.access_codes = access_codes
            if(createData.payment_systems.length === 0) delete createData.payment_systems

            try{
                const add = await this.connect.AddAdminUser(createData).then(res=>res)
                if(add.result && add.data){
                    this.showMess('success', 'Успешно', 'Пользователь добавлен')
                    this.$emit('created', add.data)
                    this.dialog = false
                } else {
                    if(add.message){
                        this.showMess('error', 'Ошибка', add.message)
                    } else {
                        this.showMess('error', 'Ошибка', 'Ошибка при добавлении пользователя')
                    }
                }
            } catch(e){
                this.showMess('error', 'Ошибка', 'Ошибка при добавлении пользователя')
                console.log('error', e)
            }

            this.loading = false
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
}
</script>
